export enum IssueSeverityEnum {
  // order matters, lowest severity first, highest last
  NO_ISSUE, INFO, WARNING, ERROR
}
